
import { getMyTaskList, getServiceStatusList, getServiceWatingList, deleteService } from '../store/api/Services';
import { useEffect, useState, useRef, Fragment } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Loader from 'react-loader-spinner'
import { Button, Col, Form, FormControl, Row } from 'react-bootstrap';
import { CardList, EyeFill, EyeSlashFill, FileEarmarkExcelFill, List, Printer, Reply, Search } from 'react-bootstrap-icons';
import DatePicker from 'react-datepicker2';
import momentJalaali from "moment-jalali";
import "react-datepicker2/src/styles/style.css";
import { getAllProvinces, getCityList } from '../store/api/LocationAPI';
import { setSelectStaffPopup } from "../store/api/Services";
import { getPageFieldList } from '../store/api/Users';
import ModalSelectStaff from "../Components/Tasks/ModalSelectStaff";
import { useForm } from 'react-hook-form';
import { InfoTypes, exportToExcel, isMobileApp, isWebApp, setDialog } from '../../store/api/CommonFunctions';
import BihamtaTable from '../../Components/BihamtaTable';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { faBroom, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import { getExtAttrSettingsForSearch, getSystemSettings } from '../store/api/SystemSettingsAPI';
import ModalReferDocument from '../../Components/Modals/ModalReferDocument';
import { getStageList } from '../../Office/store/api/FlowAPI';
import { getAllGuaranteeHolders } from '../store/api/GuaranteeApi';
import { getAllProductTypes } from '../store/api/GetAllProduct';
import { getBaseInfoList } from '../../BaseInfo/store/api/BaseInfoApi';
import { searchProductBug } from '../store/api/TaskDetailsApi';


const MyTasks = () => {
  const frmFilters = useRef();
  const [pending, setPending] = useState(false);
  const { handleSubmit, register } = useForm();
  const [showFilter, setShowFilter] = useState(true);
  const history = useHistory();
  const [stageList, setStageList] = useState(null);
  //const searchData = useRef({});
  const selectedStatusList = useRef([]);
  const selectedPhaseList = useRef([]);
  const dispatch = useDispatch();
  const settingNames = ['ProductGrouppingType'];
  const [holders, setProductHolders] = useState([]);
  const [productTypes, setProductTypes] = useState([]);
  const [popReferDoc, setReferDocPop] = useState({ show: false });
  const [considerDescList, setConsiderDescList] = useState(null);
  const { serviceStatusList, systemSettings, serviceExtraAttrSettings, provinceList, cityList, filterData, fieldList, productBugs } = useSelector(state => {
    return {
      productBugs: state.ProductReducer.productBugList?.Data,
      serviceStatusList: state.service.serviceStatusList,
      systemSettings: state.SystemSettingsReducer.systemSettings,
      serviceExtraAttrSettings: state.SystemSettingsReducer.serviceExtraAttrSettingsForSearch,
      provinceList: state.locationDataReducer.provinceList,
      cityList: state.locationDataReducer.cityList,
      filterData: state.service.searchServiceFilters,
      fieldList: state.UserReducer.pageFieldList
    }
  });
  const extAttrList = Array.isArray(serviceExtraAttrSettings) ? serviceExtraAttrSettings?.filter(s => s.SettingName.includes("Services_ExtAttr")) : [];
  const cmbAttrList = Array.isArray(serviceExtraAttrSettings) ? serviceExtraAttrSettings?.filter(s => s.SettingName.includes("Services_ComboBoxExtAttr")) : [];
  const chkAttrList = Array.isArray(serviceExtraAttrSettings) ? serviceExtraAttrSettings?.filter(s => s.SettingName.includes("Services_CheckBoxExtAttr")) : [];
  const [dateFilters, setDateFilters] = useState({
    FirstContactDate: filterData?.FirstContactDate,
    ContactDateTo: filterData?.ContactDateTo,
    ServiceDeadline: filterData?.ServiceDeadline,
    ServiceDeadlineTo: filterData?.ServiceDeadlineTo
  });
  const [selectedStaff, setStaffData] = useState({
    ID: filterData?.StaffID,
    LastName: filterData?.StaffName
  });
  const pgType = Array.isArray(systemSettings ?? "") && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
    Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
  const tableCols = [
    { colTitle: "ردیف", colName: "RowNumber", justInMobile: true },
    { colTitle: "نوع پذیرش", colName: "ServiceTypePersianText" },
    { colTitle: "شماره پذیرش", colName: "InvoiceNumber" },
    { colTitle: "تاریخ پذیرش", colName: "PFirstContactDate" },
    { colTitle: "مارک محصول", colName: "HolderName", showCondition: () => pgType === 0 },
    { colTitle: (pgType === 1 ? "نام" : "نوع") + " محصول", colName: "ProductName", justInMobile: true },
    { colTitle: "مدل محصول", colName: "ProductModel", justInMobile: true },
    { colTitle: "شماره سریال", colName: "SerialNumber" },
    { colTitle: "کد مشتری", colName: "CustomerCode" },
    { colTitle: "نام مشتری", colName: "CustomerName", justInMobile: true },
    { colTitle: "موبایل مشتری", colName: "CustomerMobile" },
    { colTitle: "تلفن مشتری", colName: "CustomerPhone" },
    { colTitle: "آدرس مشتری", colName: "ServiceAddress", colType: "string", maxLength: 110, hasTooltip: true },
    { colTitle: "تکنسین اعزامی", colName: "StaffName" },
    { colTitle: "وضعیت سرویس", colName: "Status" }
  ]
  const tableRowButtons = [
    {
      title: "نمایش سرویس", type: "show", className: "group-Btn-smalll btn-success", onclick: showService, showCondition: isMobileApp,
    },
    { title: "ارجاع به کاربر", type: "common", className: "group-Btn-smalll", onclick: showDocRefer, icon: <Reply size={19} className='rowBtn' color='blue' />, tooltip: "ارجاع به کاربر" },
    {
      title: "حذف سرویس", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
        dispatch(setDialog({
          status: 'show',
          arrayBtn: ['yes', 'no'],
          dialogTitle: 'حذف سرویس',
          dialogText: 'آیا از حذف مطمئن هستید؟',
          okOperation: deleteService(item.ServiceType, item.ServiceID, () => dispatch(getMyTaskList(filterData)))
        }))
      }
    }

  ]
  function checkFieldPermission(fieldName, actionType) {
    let result = true;
    let field = fieldList?.find(f => f.PageName === "SearchService" && f.Name === fieldName);
    if (actionType === "Read" && field) {
      result = field.IsRead === true;
    }
    if (actionType === "Edit" && field) {
      result = field.IsUpdate === false;
    }
    return result;
  }
  function onServiceStatusChanged(item) {
    if (!selectedStatusList.current) {
      selectedStatusList.current = [];
    }
    const splited = item.value.split(",");
    if (item.checked) {
      if (!selectedStatusList.current.includes(splited)) {

        selectedStatusList.current.push(...splited);
      }
    }
    else {
      selectedStatusList.current = selectedStatusList.current.filter(a => !splited.includes(a));
    }
  }
  function onServicePhaseChanged(item) {
    if (!selectedPhaseList.current) {
      selectedPhaseList.current = [];
    }
    const splited = item.value.split(",");
    if (item.checked) {
      if (!selectedPhaseList.current.includes(splited)) {

        selectedPhaseList.current.push(...splited);
      }
    }
    else {
      selectedPhaseList.current = selectedPhaseList.current.filter(a => !splited.includes(a));
    }
  }
  const search = (data) => {
    data.Skip = 0;
    if (!data.Take) {
      data.Take = 10;
    }
    if (selectedStaff && selectedStaff.ID) {
      data.StaffID = selectedStaff.ID;
      data.StaffName = selectedStaff.LastName;
    }
    if (document.getElementsByName("dateTo")[0]?.value !== "") {
      data.ContactDateTo = dateFilters.ContactDateTo;
    }
    if (document.getElementsByName("deadlineFrom")[0]?.value !== "") {
      data.ServiceDeadline = dateFilters.ServiceDeadline;
    }
    if (document.getElementsByName("deadlineTo")[0]?.value !== "") {
      data.ServiceDeadlineTo = dateFilters.ServiceDeadlineTo;
    }
    if (document.getElementsByName("dateFrom")[0]?.value !== "") {
      data.FirstContactDate = dateFilters.FirstContactDate;
    }
    if (document.getElementsByName("dateTo")[0]?.value !== "") {
      data.ContactDateTo = dateFilters.ContactDateTo;
    }
    if (document.getElementsByName("lastRefDateFrom")[0]?.value !== "") {
      data.LastRefDateFrom = dateFilters.LastRefDateFrom;
    }
    if (document.getElementsByName("lastRefDateTo")[0]?.value !== "") {
      data.LastRefDateTo = dateFilters.LastRefDateTo;
    }
    if (document.getElementsByName("archiveDateFrom")[0]?.value !== "") {
      data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
    }
    if (document.getElementsByName("archiveDateTo")[0]?.value !== "") {
      data.ArchiveDateTo = dateFilters.ArchiveDateTo;
    }
    if (document.getElementsByName("sendDateFrom")[0]?.value !== "") {
      data.SendDateFrom = dateFilters.SendDateFrom;
    }
    if (document.getElementsByName("sendDateTo")[0]?.value !== "") {
      data.SendDateTo = dateFilters.SendDateTo;
    }

    if (!checkFieldPermission("IsArchive", "Read")) {
      data.IsArchive = false;
    }
    data.StatusList = selectedStatusList.current;
    data.StatusPhaseList = selectedPhaseList.current;
    dispatch(getMyTaskList(data));
  }
  function getWatingList() {
    dispatch(getServiceWatingList());
  }
  const loadCityList = (provinceID) => {
    //searchData.current.ProvinceID = provinceID;
    dispatch(getCityList(provinceID));
  }
  function showHideFilter(hide) {
    const divFilters = document.getElementById("divFilters");
    if (hide) {
      divFilters.classList.add("hiddenRow");
      setShowFilter(false);
    }
    else {
      divFilters.classList.remove("hiddenRow");
      setShowFilter(true);
    }
  }
  function showDocRefer(row) {
    setReferDocPop({ show: true, documentHardCode: row.ServiceType, documentID: row.ServiceID, stageID: row.StageID });
  }

  function showService(row) {
    history.push(`/Services/Service/${row.ServiceID}/${row.ServiceType}`, null);
  }
  function toExcel() {
    const url = "ReceptionTasksApi/GetMyTasks";
    const searchArgs = { ...filterData };
    searchArgs.Skip = 0;
    searchArgs.Take = 0;
    setPending(true);
    exportToExcel("SearchServices", searchArgs, url, "post", tableCols, () => setPending(false));
  }
  function printReport(e) {
    const searchArgs = { ...filterData };
    history.push({
      pathname: `/PrintViewer/SearchService/${e.ctrlKey}`,
      state: {
        dataUrl: `ReceptionTasksApi/GetMyTasks`,
        method: "post",
        fetchBody: JSON.stringify(searchArgs)
      }
    });
  }
  function clearFilters() {
    frmFilters.current.reset();
    setDateFilters({
      FirstContactDate: null,
      ContactDateTo: null,
      ServiceDeadline: null,
      ServiceDeadlineTo: null
    });
    setStaffData(null);
    dispatch(getMyTaskList({ Take: 10, Skip: 0 }));
  }

  useEffect(() => {
    document.body.classList = "notMain";
    async function fetchData() {
      dispatch(getAllProvinces());
      dispatch(getServiceStatusList());
      dispatch(getSystemSettings(settingNames));
      dispatch(getStageList("service", setStageList));
      setProductHolders("PENDING");
      getAllGuaranteeHolders("", setProductHolders);
      getAllProductTypes(setProductTypes);
      dispatch(getExtAttrSettingsForSearch());
      dispatch(searchProductBug({ Take: 1000 }));
      getBaseInfoList(InfoTypes.ServiceConsiderDesc, setConsiderDescList);
      if (!fieldList || fieldList.length === 0) {
        dispatch(getPageFieldList(""));
      }
    }
    fetchData();

  }, []);
  return (
    <div className="container-fluid mt-2" style={{ minHeight: '80vh' }}>
      <br />
      <div className="card">
        <div className="card-header headerStyle">
          <FontAwesomeIcon icon={faSearch} size='lg' />&nbsp;
          جستجوی کارها</div>
        <div className="card-body bodyStyle">
          <ModalReferDocument popData={popReferDoc} setPopData={setReferDocPop} />
          <form onSubmit={handleSubmit(search)} ref={frmFilters}>
            <Row id="divFilters" className="rowBorder" >
              <div className="rowTitle">
                فیلترهای جستجو
                &nbsp;
                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
              </div>
              <ModalSelectStaff />
              <Col md={2} className="form-group" >
                <select className='form-control' defaultValue={filterData?.ServiceType ?? ""} name="ServiceType" ref={register({})}>
                  <option value="">انتخاب نوع سرویس</option>
                  <option value="repair">تعمیر</option>
                  <option value="install">نصب</option>
                </select>
              </Col>
              <Col md={2} className="form-group" >
                <select className='form-control' defaultValue={filterData?.ReceptionInAgent ?? ""} name="ReceptionInAgent" ref={register({})}>
                  <option value="">انتخاب نوع پذیرش</option>
                  <option value={false}>پذیرش در دفتر مرکزی</option>
                  <option value={true}>پذیرش در نمایندگی</option>
                </select>
              </Col>
              <Col md={2} className='form-group'>
                <input placeholder='َشماره سرویس' type='number' lang='en' className='form-control' min={0} name="InvoiceNumber" ref={register({})} defaultValue={filterData?.InvoiceNumber ?? ""}></input>
              </Col>
              {isWebApp() &&
                <Col md={2} className='form-group'>
                  <input placeholder='نام نمایندگی' type='text' lang='en' className='form-control' min={0} name="AgencyName" ref={register({})} defaultValue={filterData?.AgencyName ?? ""}></input>
                </Col>
              }
              {pgType === 0 ?
                <Fragment>
                  <Col md={2} className="form-group">
                    {holders === "PENDING" &&
                      <div className='form-control' style={{ textAlign: "center" }}>
                        <Loader type="BallTriangle" width={25} height={25} color="bb1370" />
                      </div>
                    }
                    {Array.isArray(holders) &&
                      <select className="form-control" name="ProductHolder" ref={register({})} defaultValue={filterData?.ProductHolder ?? ""}>
                        <option value="">مارک محصول را انتخاب کنید</option>
                        {holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                      </select>
                    }
                  </Col>
                  <Col md={2} className="form-group">
                    {productTypes === "PENDING" &&
                      <div className='form-control' style={{ textAlign: "center" }}>
                        <Loader type="BallTriangle" width={25} height={25} color="bb1370" />
                      </div>
                    }
                    {Array.isArray(productTypes) &&
                      <select className="form-control" name="ProductType" ref={register({})} defaultValue={filterData?.ProductType ?? ""}>
                        <option value="">نوع محصول را انتخاب کنید</option>
                        {productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                      </select>
                    }
                  </Col>
                </Fragment> :


                <Col md={2} className='form-group'>
                  <input placeholder='نام محصول' type='text' className='form-control' name="ProductName" ref={register({})} defaultValue={filterData?.ProductName ?? ""}></input>
                </Col>
              }
              {pgType === 0 &&
                <Col md={2} className='form-group'>
                  <input placeholder="مدل محصول" type='text' className='form-control' name="ProductModel" ref={register({})} defaultValue={filterData?.ProductModel ?? ""}></input>
                </Col>
              }
              <Col md={2} className='form-group'>
                <input placeholder='سریال محصول' type='text' lang='en' className='form-control' name="SerialNumber" ref={register({})} defaultValue={filterData?.SerialNumber ?? ""} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}></input>
              </Col>
              <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "2px" : "0.75rem" }}>
                <DatePicker placeholder='تاریخ پذیرش از' isGregorian={false} timePicker={false} className="form-control" name="dateFrom"
                  onChange={value => setDateFilters({ ...dateFilters, FirstContactDate: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.FirstContactDate ? momentJalaali(dateFilters.FirstContactDate) : null} />
              </Col>
              <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "2px" : "0.75rem" }}>
                <DatePicker placeholder='تاریخ پذیرش تا' isGregorian={false} timePicker={false} className="form-control" name="dateTo"
                  onChange={value => setDateFilters({ ...dateFilters, ContactDateTo: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.ContactDateTo ? momentJalaali(dateFilters.ContactDateTo) : null} />
              </Col>
              {isWebApp() &&
                <Fragment>
                  <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "2px" : "0.75rem" }}>
                    <DatePicker placeholder='تاریخ موعد از' isGregorian={false} timePicker={false} className="form-control" name="deadlineFrom"
                      onChange={value => setDateFilters({ ...dateFilters, ServiceDeadline: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ServiceDeadline ? momentJalaali(dateFilters.ServiceDeadline) : null} />
                  </Col>
                  <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "2px" : "0.75rem" }}>
                    <DatePicker placeholder='تاریخ موعد تا' isGregorian={false} timePicker={false} className="form-control" name="deadlineTo"
                      onChange={value => setDateFilters({ ...dateFilters, ServiceDeadlineTo: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ServiceDeadlineTo ? momentJalaali(dateFilters.ServiceDeadlineTo) : null} />
                  </Col>
                </Fragment>
              }
              <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "2px" : "0.75rem" }}>
                <DatePicker placeholder='تاریخ اعزام از' isGregorian={false} timePicker={false} className="form-control" name="sendDateFrom"
                  onChange={value => setDateFilters({ ...dateFilters, SendDateFrom: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.SendDateFrom ? momentJalaali(dateFilters.SendDateFrom) : null} />
              </Col>
              <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "2px" : "0.75rem" }}>
                <DatePicker placeholder='تاریخ اعزام تا' isGregorian={false} timePicker={false} className="form-control" name="sendDateTo"
                  onChange={value => setDateFilters({ ...dateFilters, SendDateTo: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.SendDateTo ? momentJalaali(dateFilters.SendDateTo) : null} />
              </Col>
              <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "2px" : "0.75rem" }}>
                <DatePicker placeholder='تاریخ انجام از' isGregorian={false} timePicker={false} className="form-control" name="lastRefDateFrom"
                  onChange={value => setDateFilters({ ...dateFilters, LastRefDateFrom: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.LastRefDateFrom ? momentJalaali(dateFilters.LastRefDateFrom) : null} />
              </Col>
              <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "2px" : "0.75rem" }}>
                <DatePicker placeholder='تاریخ انجام تا' isGregorian={false} timePicker={false} className="form-control" name="lastRefDateTo"
                  onChange={value => setDateFilters({ ...dateFilters, LastRefDateTo: value.local("en").format("YYYY-MM-DD") })}
                  value={dateFilters?.LastRefDateTo ? momentJalaali(dateFilters.LastRefDateTo) : null} />
              </Col>
              {isWebApp() &&
                <Fragment>
                  <Col md={1} className="form-group" style={{ paddingLeft: isWebApp() ? "2px" : "0.75rem" }}>
                    <DatePicker placeholder='تاریخ بایگانی از' isGregorian={false} timePicker={false} className="form-control" name="archiveDateFrom"
                      onChange={value => setDateFilters({ ...dateFilters, ArchiveDateFrom: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ArchiveDateFrom ? momentJalaali(dateFilters.ArchiveDateFrom) : null} />
                  </Col>
                  <Col md={1} className="form-group" style={{ paddingRight: isWebApp() ? "2px" : "0.75rem" }}>
                    <DatePicker placeholder='تاریخ بایگانی تا' isGregorian={false} timePicker={false} className="form-control" name="archiveDateTo"
                      onChange={value => setDateFilters({ ...dateFilters, ArchiveDateTo: value.local("en").format("YYYY-MM-DD") })}
                      value={dateFilters?.ArchiveDateTo ? momentJalaali(dateFilters.ArchiveDateTo) : null} />
                  </Col>
                </Fragment>
              }
              <Col md={2} className='form-group'>
                <input placeholder='نام مشتری' type='text' className='form-control' name='CustomerName' ref={register({})} defaultValue={filterData?.CustomerName ?? ""}></input>
              </Col>
              <Col md={2} className='form-group'>
                <input placeholder='موبایل/تلفن مشتری' className='form-control' type='number' lang='en' name="CustomerPhone" ref={register({})} defaultValue={filterData?.CustomerPhone ?? ""}></input>
              </Col>
              <Col md={2} className='form-group'>
                <input placeholder='آدرس مشتری' className='form-control' type='text' name="ServiceAddress" ref={register({})} defaultValue={filterData?.ServiceAddress ?? ""}></input>
              </Col>
              <Col md={2} className='form-group'>
                <input placeholder='توضیحات' className='form-control' type='text' name="Description" ref={register({})} defaultValue={filterData?.Description ?? ""}></input>
              </Col>
              {isWebApp() &&
                <Fragment>
                  <Col md={2} className='form-group'>
                    <select className="form-control" onChange={e => loadCityList(e.target.value)} name="ProvinceID" ref={register({})} defaultValue={filterData?.ProvinceID ?? ""} >
                      <option value="">انتخاب استان</option>
                      {provinceList && Array.isArray(provinceList) && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                    </select>
                  </Col>
                  <Col md={2} className='form-group'>
                    <select className="form-control" name="CityID" ref={register({})} defaultValue={filterData?.CityID ?? ""}>
                      <option value="">انتخاب شهر</option>
                      {cityList && Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                    </select>
                  </Col>
                </Fragment>
              }
              <Col md={2} className="form-group" >
                <select className='form-control' defaultValue={checkFieldPermission("IsArchive", "Read") ? filterData?.IsArchive : false} disabled={!checkFieldPermission("IsArchive", "Read")}
                  name="IsArchive" ref={register({})}>
                  {checkFieldPermission("IsArchive", "Read") && <option value="">انتخاب وضعیت بایگانی</option>}
                  {checkFieldPermission("IsArchive", "Read") && <option value={true}>بایگانی شده</option>}
                  <option value={false}>بایگانی نشده</option>
                </select>
              </Col>
              <Col md={2} className='form-group'>
                {serviceStatusList === "PENDING" &&
                  <div className='form-control col-md-3'>
                    <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                    <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری لیست وضعیت</span>
                  </div>
                }
                {serviceStatusList && Array.isArray(serviceStatusList) &&
                  <BihamtaMultiSelect placeholder="انتخاب وضعیت سرویس" dataSource={serviceStatusList} valueItem="ID" displayItem="Status" onItemCheckChanged={onServiceStatusChanged} defaultCheckedList={filterData?.StatusList} />
                }
              </Col>
              <Col md={2} className='form-group'>
                <BihamtaMultiSelect placeholder="انتخاب مرحله سرویس" dataSource={stageList} valueItem="ID" displayItem="StageName" onItemCheckChanged={onServicePhaseChanged} defaultCheckedList={filterData?.StatusPhaseList} />
              </Col>
              {isWebApp() &&
                <Col md={2} className='form-group'>
                  <select className='form-control' name='ShowSwapped' ref={register({})} defaultValue={filterData?.ShowSwapped ?? false}>
                    <option value={false}>وضعیت جایگزینی</option>
                    <option value={true}>نمایش سرویس های جایگزین شده</option>
                  </select>
                </Col>
              }
              <Col md={2} className='form-group'>
                <FormControl name="NewProductSerial" ref={register({})} placeholder='سریال جایگزین' defaultValue={filterData?.NewProductSerial ?? ""} />
              </Col>
              <Col md={2} className='form-group'>
                <input placeholder='نام تکنسین اعزامی' type="text" className='form-control' readOnly value={selectedStaff?.LastName ?? ""} />
                <Button className='btn-input-tiny' style={{ top: "8px" }} onClick={() => { dispatch(setSelectStaffPopup({ status: 'show', onSelect: setStaffData })) }}><List size={21} /></Button>
              </Col>

              {isWebApp() && extAttrList.length > 0 &&
                extAttrList.map((item, i) =>
                  <div key={'Ext' + i} className="form-group col-md-2">
                    <input className="form-control" placeholder={item.SettingValue} name={item.SettingName.replace("Services_", "").replace("_Title", "")} ref={register({})} type="text"
                      defaultValue={filterData ? (filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] ?? '') : ""} />
                  </div>
                )
              }
              {isWebApp() && cmbAttrList.length > 0 && cmbAttrList.filter(s => s.SettingName.includes('_Title')).map((item, i) =>
                <div key={i} className="form-group col-md-2">
                  <select className="form-control" ref={register({})} name={item.SettingName.replace("Services_", "").replace("_Title", "")} defaultValue={filterData ? filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] : ''}>
                    <option value=''>انتخاب {item.SettingValue}</option>
                    {cmbAttrList.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue &&
                      cmbAttrList.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue.split("|").map((item, i) => { return (<option key={i} value={item}>{item}</option>) })
                    }
                  </select>
                </div>
              )
              }
              <Col md={2} className='form-group'>
                {considerDescList?.Data ?
                  <select className="form-control" defaultValue={filterData?.ConsiderDescriptionID ?? ""} name="ConsiderDescriptionID" ref={register()}>
                    <option value="">انتخاب شرح رسیدگی</option>
                    {considerDescList.Data.map((desc, i) => <option key={i} value={desc.ID}>{desc.InfoName}</option>)}
                  </select> :
                  <div className='form-control'>
                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;<span style={{ color: "gray" }}>در حال بارگذاری فهرست </span>
                  </div>
                }
              </Col>
              <Col md={2} className='form-group'>
                {Array.isArray(productBugs ?? "") ?
                  <Form.Control as="select" className='scThin' defaultValue={filterData?.BugID ?? ""} name="BugID" ref={register()}>
                    <option value="">انتخاب ایراد</option>
                    {productBugs.map((bug, i) => <option key={i} value={bug.ID}>{bug.Bug + ` (${bug.Code})`}</option>)}
                  </Form.Control> :
                  <div className='form-control'>
                    <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;<span style={{ color: "gray" }}>در حال بارگذاری فهرست ایرادات</span>
                  </div>
                }
              </Col>
              {isWebApp() &&
                <Col md={2} className='form-group'>
                  <select className='form-control' name="SortOrder" ref={register({})} defaultValue={filterData?.SortOrder ?? ""}>
                    <option value="" style={{ color: "gray" }}>مرتب سازی بر اساس</option>
                    <option value="UPDATE DESC">آخرین تغییر</option>
                    <option value="CONTACT">تاریخ پذیرش</option>
                    <option value="CONTACT DESC">تاریخ پذیرش-نزولی</option>
                    <option value="NUMBER">شماره سرویس</option>
                    <option value="NUMBER DESC">شماره سرویس-نزولی</option>
                    <option value="HOLDER">مارک محصول</option>
                    <option value="HOLDER DESC">مارک محصول-نزولی</option>
                    <option value="PNAME">نام/نوع محصول</option>
                    <option value="PNAME DESC">نام/نوع محصول-نزولی</option>
                    <option value="PMODEL">مدل محصول</option>
                    <option value="PMODEL DESC">مدل محصول-نزولی</option>
                    <option value="CUST">نام مشتری</option>
                    <option value="CUST DESC">نام مشتری-نزولی</option>
                  </select>
                </Col>
              }
              <Col md={2} className='form-group'>
                <select className='form-control' name="Take" ref={register({})} defaultValue={filterData?.Take ?? "10"}>
                  <option value="0">تعداد در صفحه</option>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </Col>
            </Row>

            <div className='mt-1' style={{ textAlign: "right" }}>
              <Button className='group-Btn' type="submit"><Search size={15} />&nbsp;جستجوی سرویس ها&nbsp;</Button>
              <Button variant='secondary' className='group-Btn' onClick={getWatingList}><CardList size={15} />&nbsp;لیست انتظار</Button>
            </div>
          </form>
          {!pending &&
            <div style={{ padding: 0, width: "100%", textAlign: "left" }}>
              <FileEarmarkExcelFill onClick={toExcel} size={25} color="green" style={{ cursor: "pointer" }} className="hoverIcon" />
              <Printer onClick={printReport} size={25} style={{ cursor: "pointer" }} className="hoverIcon" color='blue' />
            </div>}
          {pending && <div style={{ padding: 0, width: "100%", textAlign: "left" }}><Loader type="BallTriangle" color="#bb1370" height={18} style={{ textAlign: "left", alignItems: "left" }} /></div>}
          <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} filterData={filterData} rowClick={showService} fixedHeight className='mb-0 mt-0'
            searchMethod={(data) => dispatch(getMyTaskList(data))} reducerName="task" objectName="myTasks" hasPaging={true} style={{ whiteSpace: "nowrap" }} />
        </div>
      </div>
    </div>
  )
}
export default MyTasks;
